import React from "react";

const DashBoard = () => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <h4 className="page-title">Dashboard</h4>
          </div>
        </div>
      </div>
      <div className="row"></div>
    </>
  );
};

export default DashBoard;
